<script>
  export let category = null;
  import * as Constants from '../Constants';
  import * as Utils from '../services/Utils';
  import { _ } from '../services/i18n';
  // import { paginate, LightPaginationNav } from 'svelte-paginate';
  import Pagination from '../components/Pagination.svelte';

  // Item
  import { getContext } from 'svelte';
  const { open } = getContext('simple-modal');
  import GalleryModelsItem from './GalleryModelsItem.svelte';

  let items = [];
  let pageSize = 18;
  let currentPage = 1;
  let lastPage = 1;
  let total = 0;
  let loading = false;
  let error = false;

  function fetchItems(params = {page: 1, category: null}) {
    loading = true;
    console.debug('3D models params', params);
    Utils.fetchData(Constants.HOST_SERVICES + 'getModels', params)
        .then(response => response.json())
        .then(response => {
          currentPage = response.result.pag;
          total = response.result.items.length;
          lastPage = response.result.pags;
          items = response.result.items;
        })
        .catch(error => {
          error = true;
          console.error(error);
        })
        .finally(() => {
          loading = false;
        });
  }
  
  $: fetchItems({page: 1, category: category}); // To run reactive statement.

	const showItem = (name) => {
		open(GalleryModelsItem, { name: name });
	};
</script>

<!-- HTML ----------------------------------------------------------------------->
<div id="container" class="fadeIn def_back gallery-models">
  {#if category !== null}
    <h2 id="title-category" class="titles {category}">
      <i class="fas fa-2x fa-{Constants.GALLERY_MODELS_TYPES[category] || Constants.GALLERY_MODELS_TYPES_DEFAULT}"></i>
      <span> {$_('menu.sez3dModels' + category.toTitleCase())}</span>
    </h2>
  {:else}
    <h2 class="titles">{$_('menu.sez3dModels')}</h2>
  {/if}

  {#if loading}
    <div class="lds-css">
      <div class="lds-eclipse"><div></div></div>
    </div>
  {:else if items}
    <ul class="thumbs">
      {#each items as elem}
        <li class="thumb {elem.type} category">
          <span on:click={showItem(elem.name)}>
            <img src="{Constants.PUBLIC_MODELS_IMAGES_3D + elem.name + '.min.jpg'}"
                width="178px" height="178px" class="loading" alt="{elem.name}" />
          </span>
          <span class="thumb_title">{@html elem.title_en}</span>
          <i class="fas fa-{Constants.GALLERY_MODELS_TYPES[elem.type] || Constants.GALLERY_MODELS_TYPES_DEFAULT}"></i>
        </li>
      {/each}
    </ul>
 

    {#if lastPage > 1}
      <Pagination
        {currentPage}
        {lastPage}
        on:change="{(ev) => fetchItems({page: ev.detail, category: category})}"
      ></Pagination>
    {/if}
  {:else if error}
    <div class="gallery-error">
      <i class="far fa-times-circle"></i>
      {$_('errors.UNKNOWN')}
    </div>
  {/if}
</div>

<!-- STYLES ----------------------------------------------------------------------->
<style type="text/scss">
@import '../../public/styles/variables';
@import '../../public/styles/mixins';

$models-transp-amount: 0.5;

@mixin models-background($color) {
  background-color: transparentize($color, $models-transp-amount);
  border-color: transparentize($color, 0.3);
}

/** Models titles */
#container {
  #title-category {
    color: $idro-palette-first;
    &.buildings { color: $idro-gallery-buildings; }
    &.characters { color: $idro-gallery-characters; }
    &.weapons { color: $idro-gallery-weapons; }
    &.animals { color: $idro-gallery-animals; }
    &.objects { color: $idro-gallery-objects; }
    &.monsters { color: $idro-gallery-monsters; }
    &.vehicles { color: $idro-gallery-vehicles; }
  }
  .titles {
    i {
      margin-top: -5px;
      vertical-align: middle;
    }
  }

  .thumbs .thumb {
    @include models-background($idro-palette-first);
    @include border-radius(20px);
    &.buildings { @include models-background($idro-gallery-buildings); }
    &.characters { @include models-background($idro-gallery-characters); }
    &.weapons { @include models-background($idro-gallery-weapons); }
    &.animals { @include models-background($idro-gallery-animals); }
    &.objects { @include models-background($idro-gallery-objects); }
    &.monsters { @include models-background($idro-gallery-monsters); }
    &.vehicles { @include models-background($idro-gallery-vehicles); }
    &:hover {
      .thumb_title, .thumb_title:hover {
        bottom: 0;
      }
    }
    &.category {
      height: 205px;
      &:hover {
        .thumb_title, .thumb_title:hover {
          bottom: 27px;
        }
      }
      /* without hover for mobile */
      @media #{$tablet-m} {
        .thumb_title {
          bottom: 27px;
        }
      }
      i.fas {
        margin-top: 8px;
      }
    }
    img {
      cursor: pointer;
      @include border-radius(20px);
    }
    .thumb_title {
      color: $idro-palette-white;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      text-align: center;
      letter-spacing: 1px;
      font-weight: bold;
      font-variant: small-caps;
      width: 174px;
      height: 40px;
      padding: 2px;
      font-size: $font-size-base;
      bottom: -50px;
      left: 0;
      text-shadow: 1px 1px 1px rgba(0,0,0,0.4);
      background: transparentize($idro-palette-first, 0.4);
      @include box-shadow(0 0 5px 0 $idro-palette-black);
      @include border-radius(20px);
      @include transition(all 0.2s ease-in-out);
    }
    /* without hover for mobile */
    @media #{$tablet-m} {
      .thumb_title {
        bottom: 0;
      }
    }
  }
}
</style>
